import React from "react";

export const Context = React.createContext(null);

const getContext = () => {
  return {
    context: Context
  };
};

const GlobalContext = {
  context: Context
};

export { getContext, GlobalContext };

export default Context;
